import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { RowVO } from '@/types/index';
import { AbstractModelImpl } from '@/services/common/abstract-model';

export const GridModel = Symbol('GridModel');

export interface GridModel extends AbstractModelImpl<Partial<RowVO>[]> {
    get modelData(): Partial<RowVO>[]
    update(getUpdateValue: (value: Partial<RowVO>[]) => Partial<RowVO>[]): void;
}

@injectable()
export class GridModelImpl extends AbstractModelImpl<Partial<RowVO>[]> implements GridModel {
    _modelData: Partial<RowVO>[] = [];

    constructor(
    ) {
        super();
    }
}
